<template>
  <div>
    <b-overlay :show="loading" class="content">
      <div class="mb-3 text-center">
        <hr />
        <strong>{{ $t("view.club.menus.transactionSplitSums") }}</strong>
        <hr />
      </div>
      <div class="w-100 mb-3 float-left">
        <button
          type="button"
          class="btn btn-light text-right"
          @click="showFilters = true"
        >
          <font-awesome-icon class="mr-2 ml-2" icon="sliders-h" /> تنظیمات صفحه
        </button>
      </div>
      <div class="row">
        <table class="table table-striped bg-white text-center">
          <thead>
            <tr>
              <th
                v-for="field in fields"
                v-if="field.showCell"
                :key="field.key"
              >
                {{ $t("param." + field.key) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items">
              <td v-for="field in fields" v-if="field.showCell">
                <span v-if="field.key == 'record'">
                  {{ index + (currentPage - 1) * perPage + 1 }}
                </span>
                <span v-else-if="field.key == 'actions'">
                  <button
                    class="btn btn-info btn-sm m-1"
                    @click="onShowDatails(item)"
                  >
                    جزئیات
                  </button>
                </span>
                <span v-else v-bind:class="{ 'card-number': field.cardNumber }">
                  {{
                    field.money
                      ? new Intl.NumberFormat().format(item[field.key])
                      : item[field.key]
                  }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-pagination
        dir="ltr"
        pills
        @input="initTable"
        v-model="currentPage"
        :total-rows="totalFilteredRows"
        :per-page="perPage"
        size="sm"
      ></b-pagination>
    </b-overlay>
    <b-modal centered hide-footer v-model="showDetails">
      <div class="text-center">
        <strong class="d-block mb-3">{{
          $t("view.club.transactionDetails")
        }}</strong>
        <table class="table text-center table-sm table-light">
          <tr v-for="field in fields" v-if="field.shotDetails">
            <th>{{ $t("param." + field.key) }}</th>
            <td>
              {{
                field.money
                  ? new Intl.NumberFormat().format(selected[field.key])
                  : selected[field.key]
              }}
            </td>
          </tr>
        </table>
      </div>
    </b-modal>
    <b-modal size="lg" hide-footer v-model="showFilters">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-7 float-right">
            <table class="table table-borderless text-right">
              <tr>
                <td>{{ $t("param.table.perPage") }}</td>
                <td>
                  <b-form-select
                    :options="perPageOptions"
                    class="form-control"
                    v-model="perPageSelectedOption"
                  ></b-form-select>
                </td>
              </tr>
              <tr>
                <td>{{ $t("param.table.fromDate") }}</td>
                <td>
                  <date-picker
                    color="#f5c842"
                    v-model="fromDate"
                    :clearable="true"
                  />
                </td>
              </tr>
              <tr>
                <td>{{ $t("param.table.toDate") }}</td>
                <td>
                  <date-picker
                    color="#f5c842"
                    v-model="toDate"
                    :clearable="true"
                  />
                </td>
              </tr>
            </table>
          </div>
          <div class="col-12 col-md-5 float-right">
            <table class="table text-right table-light">
              <tr v-for="(field, index) in fields" v-if="field.shotDetails">
                <th>{{ $t("param." + field.key) }}</th>
                <td>
                  <b-form-checkbox
                    switch
                    v-model="fields[index].showCell"
                    size="lg"
                  ></b-form-checkbox>
                </td>
              </tr>
            </table>
          </div>
          <button class="btn btn-outline-dark" @click="initFilters">
            اعمال تنظیمات
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      showFilters: false,
      showSplits: false,
      showDetails: false,
      selected: {},
      items: [],
      fields: [
        {
          key: "record",
          showCell: true,
          shotDetails: false
        },
        {
          key: "splitYear",
          showCell: true,
          shotDetails: true
        },
        {
          key: "splitMonthName",
          showCell: true,
          shotDetails: true
        },
        {
          key: "totalSplitValue",
          showCell: true,
          shotDetails: true,
          money: true
        },
        {
          key: "status",
          showCell: true,
          shotDetails: true
        },
        {
          key: "amountPaid",
          showCell: true,
          shotDetails: true,
          money: true
        },
        {
          key: "actions",
          showCell: true,
          shotDetails: false
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10
    };
  },

  beforeMount() {
    this.initTable();
  },

  mounted() {
    this.totalRows = this.items.length;
  },

  methods: {
    initFilters() {
      this.showFilters = false;
      this.perPage = Number(this.perPageSelectedOption);
      this.initTable();
    },

    initTable() {
      this.loading = true;

      const data = {
        Search: "",
        Start: (this.currentPage - 1) * this.perPage,
        Length: this.perPage,
        FromDate: this.fromDate,
        ToDate: this.toDate
      };

      axios({
        method: "post",
        url: "/api/App/GetTransactionSplitSum",
        data: data
      })
        .then(response => {
          this.items = response.data.meta.transactionSplitSums;
          this.totalRows = response.data.meta.totalRows;
          this.totalFilteredRows = response.data.meta.totalFilteredRows;
          this.loading = false;
        })
        .catch(error => {});
    },

    onShowDatails(item) {
      this.selected = item;
      this.showDetails = true;
    }
  }
};
</script>
